import React, { useState, useEffect } from "react";
import Form from "src/components/CustomForm";
import Grid from "@mui/material/Grid";
import useForm from "src/hooks/use-form";
import { useAlertContext } from "src/hooks/use-alert";
import AssetValidator from "src/validators/asset-validator.ts";
import { AssociateAsset, CreateAsset } from "src/apis/complex";
import { UpdateAsset } from "src/apis/complex";
import { useNavigate } from "react-router-dom";
import { AssetTypes } from "src/util/utility_enums";
import { assetProtocols } from "src/util/utility_enums";
import { setInputs } from "src/util/generateInputs";
import { styled } from "@mui/material";

const useStyles = styled((theme) => {
  return {
    backButton: {
      marginRight: theme.spacing(1),
    },
    root: {
      display: "inline",
      flexDirection: "column",
      alignItems: "center",
      width: "100%",
    },
    field: {
      width: "30%",
      marginBottom: theme.spacing(2),
    },
  };
});

const validator = new AssetValidator();

let properties = {
  name: { value: "", type: "text", isTouched: false, hasError: false },
  protocol: {
    value: "",
    type: "select",
    isTouched: false,
    hasError: false,
    enum: assetProtocols,
  },

  serialNumber: { value: "", type: "text", isTouched: false, hasError: false },

  type: {
    value: "",
    type: "select",
    isTouched: false,
    hasError: false,
    enum: AssetTypes,
  },

  isActive: {
    value: true,
    type: "checkbox",
    checked: true,
    isTouched: false,
    hasError: false,
  },

  aiSupervision: {
    value: true,
    type: "checkbox",
    checked: true,
    isTouched: false,
    hasError: false,
  },
  description: {
    value: "",
    type: "text",
    multiline: true,
    isTouched: true,
    hasError: false,
  },

  position: {
    floorNumber: {
      value: "",
      type: "number",
      parentName: "position",
      isTouched: false,
      hasError: false,
    },
    roomNumber: {
      value: "",
      type: "number",
      parentName: "position",
      isTouched: true,
      hasError: false,
    },
    latitude: {
      value: "",
      parentName: "position",
      type: "text",
      isTouched: false,
      hasError: false,
    },
    longitude: {
      value: "",
      parentName: "position",
      type: "text",
      isTouched: false,
      hasError: false,
    },
    liftShaftIdentificationCode: {
      value: "",
      type: "text",
      parentName: "position",
      isTouched: false,
      hasError: false,
    },
    outSideIdentificationCode: {
      value: "",
      type: "text",
      parentName: "position",
      isTouched: false,
      hasError: false,
    },
    terraceIdentificationCode: {
      value: "",
      type: "text",
      parentName: "position",
      isTouched: false,
      hasError: false,
    },
  },
};

export default function AssetForm({ props }) {
  const navigate = useNavigate();
  const alert = useAlertContext();
  var updating;
  const [visible, setVisible] = useState(false);
  if (props.updateInfo) {
    updating = true;
  }
  var x = 0;
  useEffect(() => {
    console.log("in useEffect start ");

    if (updating === true) {
      for (const prop in props.updateInfo) {
        if (properties[prop] !== undefined) {
          properties[prop].value = props.updateInfo[prop];
          properties[prop].isTouched = true;
        }
      }
    }
    x = x + 1;
    console.log("i am x: ", x);
  }, [updating]);

  const conditionSelectChangeHandler = (props, handler) => {
    handler(props);
    switch (true) {
      case props.target.value !== "":
        setVisible(true);
        break;
      // case "2":
      //   break;
      // case "3":
      //   break;
      // case "4":
      //   break;

      default:
        setVisible(false);
        break;
    }
  };

  properties.type.conditionSelect = true;
  properties.type.conditionSelectChangeHandler = conditionSelectChangeHandler;

  const { inputs, errorMessages, isValid, hasError, submitValidationHandler } =
    useForm(validator, properties);

  const { position } = inputs;

  // const { position, ...assetInputs } = inputs;

  // const position = useForm(positionValidator, positionProperties);

  const classes = useStyles();

  const positonInputs = setInputs(classes, position, errorMessages.position);

  const handleSubmit = async (event) => {
    event.preventDefault();
    submitValidationHandler(event);
    // position.submitValidationHandler(event);
    if (!hasError && isValid) {
      // if (hasError && position.hasError && isValid && position.isValid) {
      let data = {};

      for (var input in inputs) {
        if (inputs[input].value === undefined) {
          data[input] = {};
          for (const subInput in inputs[input]) {
            data[subInput] = inputs[input][subInput].value;
          }
        } else {
          data[input] = inputs[input].value;
        }
        if (input === "aiSupervision") {
          data["isActiveAi"] = inputs[input].value; 
        }
      }
      delete data["aiSupervision"]
      delete data["position"];
      data.type = { id: data.type };

      // data.building = props.buildingData;
      if (!props.updateInfo) {
        const response = await CreateAsset(data);
        if (response.success) {
          var alertMessage = "Asset created successfully!";
          if (props.buildingData) {
            const associateResponse = await AssociateAsset({
              id: response.object.id,
              buildings: [props.buildingData.id],
            });
            if (associateResponse.success) {
              alertMessage = "Asset associated successfully!";
            } else {
              alert.setError((prev) => [...prev,{
                status: true,
                messages: associateResponse.errors,
              }]);
              return props.custom ? props.onSubmit(false) : null;
            }


            
            // success alert
            alert.setSuccess((prev) => [...prev,{
              status: true,
              message: alertMessage,
              index:prev.length
            }]);
            if (isNaN(props.steps)) {
              return props.custom
                ? props.onSubmit(false, true)
                : navigate("..");
            }
            if(props.inWizard){
             
              props.inWizard=false
              return props.custom ? props.onSubmit(false) :  navigate("/dashboard/explore-complexes");
            }
            props.handleNext();
          }
        } else {
          alert.setError((prev) => [...prev,{ status: true, messages: response.errors,index:prev.length }]);
          return props.custom ? props.onSubmit(false) : null;
        }
      } else {
        data.id = props.updateInfo.id;
        var response = await UpdateAsset(data);
        var message = "Asset updated successfully!";
        if (response.success) {
          // success alert
          alert.setSuccess((prev) => [...prev,{
            status: true,
            message: message,
            index:prev.length
          }]);
        } else {
          alert.setError((prev) => [...prev,{ status: true, messages: response.errors,index:prev.length }]);
          return props.custom ? props.onSubmit(false) : null;
        }
      }
    }
    return props.custom ? props.onSubmit(false) : null;
  };

  return (
    <Form
      title={"Asset"}
      inputs={inputs}
      errorMessages={errorMessages}
      isValid={isValid}
      custom={props.custom ?? false}
      hasError={hasError || position.hasError ? true : false}
      activeStep={props.activeStep}
      steps={props.steps}
      onSubmit={handleSubmit}
      externalSubmit={props.externalSubmit ?? null}
      handleBack={props.handleBack ?? null}
    >
      <Grid key="position" item md={12}>
        <h3>Asset position</h3>
      </Grid>
      {visible && positonInputs}
    </Form>
  );
}
